import { useState } from 'react'

/**
 * Disclosure state for an agent tool-result card. The card auto-expands once it
 * has a body of results to show (`hasBody`) and stays collapsed for empty
 * results; once the user toggles, their choice wins and keeps winning.
 * `errored` keeps a failed call collapsed by default — the body (often a raw
 * error dump) stays one click away instead of dominating the thread.
 * `defaultOpen` forces the card open even with no body or an error (stories
 * use it to render the expanded body). This is the logic half of the
 * disclosure — the View still owns `hasBody` (its shape varies per tool) and
 * reads `open` for its own JSX.
 */
export function useToolCardOpen(
  hasBody: boolean | undefined,
  defaultOpen = false,
  errored = false
): { open: boolean; onToggle: () => void } {
  const [userOpen, setUserOpen] = useState<boolean | null>(null)
  const open = userOpen ?? (defaultOpen || (Boolean(hasBody) && !errored))
  return { open, onToggle: () => setUserOpen(!open) }
}
